import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Upload from "@/views/Upload";

Vue.use(VueRouter)

const routes = [
  {
    path: '/upload',
    name: 'Upload',
    component: Upload
  },
  {
    path: '*',
    name: 'Home',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
